
import { useEffect } from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';
import ROUTERS from "../../commons/constans/router";

function useNativeRegisterAward(token, userInfo) {
  const navigate = useNavigate();

  useEffect(() => {
    const sendImageIdForRanking = (id) => {
      navigate(ROUTERS.AWARD_REGISTER + '?id=' + id);
    }

    window.sendImageIdForRanking = sendImageIdForRanking

    return () => window.sendImageIdForRanking = undefined
    }, [])

  return [];
}

export default useNativeRegisterAward;
